import { useState } from "react";
import classes from "../../../styles/ServiceRepairModal.module.scss";
import { selectState, setConsumables } from "../serviceAndRepair.slice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import { IInput } from "Dashboard/scenes/Consumables/domain/IInput";
import { BiSearchAlt } from "react-icons/bi";

const NameAsSearch = () => {
  const dispatch = useAppDispatch();

  const [searchActive, setSearchActive] = useState<boolean>(false);
  const [searchText, setSearchText] = useState("");
  const { allConsumables } = useSelector(selectState);

  const compareConsumablesForSearch = (searchText: string): any => {
    return (c1: IInput, c2: IInput) => {
      const searchTerms = searchText.split(" ");
      let c1Points = 0;
      for (let i = 0; i < searchTerms.length; i++) {
        if (c1.item.name.toLowerCase().includes(searchTerms[i].toLowerCase())) {
          c1Points += 1;
        }
        if (c1.billOfLandingId.toLowerCase().includes(searchTerms[i].toLowerCase())) {
          c1Points += 1;
        }
      }
      let c2Points = 0;
      for (let i = 0; i < searchTerms.length; i++) {
        if (c2.item.name.toLowerCase().includes(searchTerms[i].toLowerCase())) {
          c2Points += 1;
        }
        if (c2.billOfLandingId.toLowerCase().includes(searchTerms[i].toLowerCase())) {
          c2Points += 1;
        }
      }
      return c2Points - c1Points;
    }
  };

  const updateSearch = (searchText: string) => {
    if (searchText === "") {
      dispatch(setConsumables(allConsumables));
    }
    setSearchText(searchText);
    const consumables = [...allConsumables];
    consumables.sort(compareConsumablesForSearch(searchText));
    dispatch(setConsumables(consumables));
  };

  return (
    <>{!searchActive
      ? <span className={classes.pointer} onClick={() => setSearchActive(true)}>
        {searchText !== "" ? searchText : "naziv"}
        <BiSearchAlt />
      </span>
      : <input type="text"
        autoFocus
        onChange={(e) => updateSearch(e.target.value)}
        onBlur={() => setSearchActive(false)}
        value={searchText} />}
    </>
  );
}

export default NameAsSearch;
